let tail: Promise<unknown> = Promise.resolve();

/** Runs write jobs one at a time, so a read-then-write in applyLocal never interleaves with another. */
export function withWriteLock<T>(fn: () => Promise<T>): Promise<T> {
  const run = tail.then(fn, fn);
  tail = run.catch(() => undefined);
  return run;
}
